import React from 'react';
import { Grid2 } from '@mui/material';
import PageWithTitle from '../../components/atom/PageWithTitle';
import { useTranslation } from 'react-i18next';
import ShowTimeslotPicker from '../../components/ShowTimeslotPicker';

const CateringViewSelector = () => {
    const { t } = useTranslation();

    return (
        <PageWithTitle title={t('bookingitems.cateringview')}>
            <Grid2 size={{ xs: 12 }}>
                <ShowTimeslotPicker baseUrl="/cateringview" />
            </Grid2>
        </PageWithTitle>
    );
};

export default CateringViewSelector;
